<div class="landing-container">
  <div class="landing-content">
    <h3 class="text-center">{{'welcomeToEinvoicRequestPortal' | translate}}</h3>
    <div [innerHTML]="'welcomeToEinvoicRequestPortalDescription' | translate"></div>
    <button
      pButton 
      type="button"
      (click)="proceed()"
      class="ey-button-dark me-2 mt-0 text-center"
    >{{ 'proceed' | translate }}</button>
  </div>
</div>
